export default {
  en: {
    name: 'Name',
    code: 'Code',
    status: 'Status',
    all: 'All',
    specific: 'Specific'
  },
  th: {
    name: 'ชื่อ',
    code: 'รหัส',
    status: 'สถานะ',
    all: 'ทั้งหมด',
    specific: 'กำหนดเอง'
  }
}
